// src/services/auth.service.js
export const loginUser = async (username, password) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Auth/Login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user: username,
        password: password
      }),
    });

  

    const result = await response.json();

      console.log(response);
        console.log(result);

    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Credenciales inválidas');
    }

    const { token, email, roles, dni, id } = result.data;

    // Guardamos en localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify({ id, dni, email, roles }));

    return {
      id,
      dni,
      email,
      roles,
      token,
    };
  } catch (error) {
    console.error('Error en login:', error);
    throw error;
  }
};


export const validateToken = async (token) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/Auth/ValidateToken`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ Token: token }), // 👈 según tu backend
    });

    const result = await response.json();

    // Estructura esperada: { success: 1, data: true }
    if (result.success === 1 && result.data === true) {
      return true; // token válido
    }

    return false; // token inválido
  } catch (error) {
    console.error("Error validando token:", error);
    return false;
  }
};
